import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { textTranslate, translate } from "../../../../utils/i18n";

const DeleteDeviceFileAttachments = ({ isOpenDeleteModal, toggle, file, device, onSubmitDelete }) => {
  return (
    <div>
      <Modal isOpen={isOpenDeleteModal} toggle={toggle}>
        <ModalHeader toggle={toggle}>{translate("deleteAttatchment")}</ModalHeader>
        <ModalBody>
          <React.Fragment></React.Fragment>
          <p>
            {textTranslate("deleteInstallationOrderDeviceAttatchment")
              .replace("{FIL}", file.name)
              .replace("{DEVICE}", device && "name" in device && device.name)}
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={onSubmitDelete}>
            {translate("delete")}
          </Button>
          <Button color="secondary" onClick={toggle}>
            {translate("cancel")}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default DeleteDeviceFileAttachments;
